import {filter, map} from 'rxjs/operators';
import type {Observable} from 'rxjs';
import type {ws} from '@/types';
type MsgType = ws.MsgType;

export interface MsgBase<T1, T2 = unknown> {
  riskLevelEr?: string;
  orders: T1;
  wallets: T2;
  sequence: number;
  timestamp: number;
  type: MsgType;
}

export function createOrders$<Orders>(msg$: Observable<MsgBase<Orders>>) {
  const orders$ = msg$.pipe(filter((o: MsgBase<Orders>) => !!o.orders));
  const snapshotOrders$ = orders$.pipe(
    filter((o: MsgBase<Orders>) => o.type === 'snapshot'),
    map((o): Orders => o.orders)
  );
  const incrementalOrders$ = orders$.pipe(
    filter((o: MsgBase<Orders>) => o.type === 'incremental'),
    map((o): Orders => o.orders)
  );
  return {
    orders$,
    snapshotOrders$,
    incrementalOrders$,
  };
}
